import Cookie from 'js-cookie';
import log from './ChatDebug';

const getChatConfig = () => {
  let chatConfig = Cookie.get('chatConfig');
  log('Check chatConfig from cookie: ', chatConfig);
  if (chatConfig) {
    chatConfig = JSON.parse(chatConfig);
    log('Convert chat config from cookie to JSON: ', chatConfig);
  } else {
    chatConfig = !!window.chatConfig && window.chatConfig;
    log('Loading chat config from Ensighten : ', chatConfig);
  }
  return chatConfig;
};

const testPageType = pageTypes => {
  const jlDataPageType =
    window.jlData &&
    window.jlData.page &&
    window.jlData.page.pageInfo &&
    window.jlData.page.pageInfo.pageType;
  const pageTypeSetting = pageTypes.filter(
    pageType => pageType === jlDataPageType
  );

  return (
    pageTypeSetting &&
    Array.isArray(pageTypeSetting) &&
    pageTypeSetting.length > 0
  );
};

const testBreadCrumbs = breadCrumbs => {
  const jlDataBreadCrumbs =
    window.jlData &&
    window.jlData.page &&
    window.jlData.page.pageInfo &&
    window.jlData.page.pageInfo.breadCrumb;

  const breadCrumbSetting = jlDataBreadCrumbs.filter(crumb =>
    breadCrumbs.includes(crumb.value)
  );
  return (
    breadCrumbSetting &&
    Array.isArray(breadCrumbSetting) &&
    breadCrumbSetting.length > 0
  );
};

const createChatConfig = () => {
  const chatConfig = getChatConfig();
  return (
    !!chatConfig &&
    chatConfig.chats &&
    chatConfig.chats.filter(
      chat =>
        testPageType(chat.conditions.pageTypes) &&
        testBreadCrumbs(chat.conditions.breadCrumbs)
    )
  );
};

export default createChatConfig;
